
function NotFound () {
    return(
       <div className="not-found">
           <h2>Uh Oh, That Page Does Not Exist</h2>
            <img className="err-img" src="https://images.unsplash.com/photo-1602984338060-bfddce132ebc?ixid=MnwxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8&ixlib=rb-1.2.1&auto=format&fit=crop&w=1350&q=80" alt="" />
       </div> 
    )
}

export default NotFound;